// 快船前端运行时配置
//
// Vite 在构建时通过 define 把 import.meta.env.VITE_* 替换为字面量
// 本地开发时未设置则为空，使用 vite.config.ts 中的 proxy 走相对路径

export const APP_ID = import.meta.env.VITE_APP_ID as string;
export const UNIFIED_AUTH_BASE = (import.meta.env.VITE_UNIFIED_AUTH_BASE as string) || 'https://unified-auth-admin.pages.dev';
export const WORKER_ORIGIN = (import.meta.env.VITE_WORKER_ORIGIN as string) || '';

// 拼接 Worker origin；若未配置（本地走 Vite proxy）则用相对路径
export function workerUrl(path: string): string {
  if (WORKER_ORIGIN) {
    return `${WORKER_ORIGIN}${path}`;
  }
  return path;
}

// WebSocket URL（必须显式拼接，因为 Vite proxy 不会自动转换 wss://）
export function workerWsUrl(path: string): string {
  if (WORKER_ORIGIN) {
    const wsOrigin = WORKER_ORIGIN.replace(/^http/, 'ws');
    return `${wsOrigin}${path}`;
  }
  // 本地开发：用同源 ws，Vite 会代理
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${path}`;
}
